import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';
import { inject } from '@angular/core';
import { LoginService } from '@services/login.service';

export const addAuthInterceptor: HttpInterceptorFn = (req, next) => {
  // Check if the request URL contains any of the ignore requests from environment
  if (environment.ignoreAuthRequests.some(url => req.url.includes(url))) {
    return next(req);
  }

  // Clone the request and add the custom header
  const modifiedRequest = req.clone({
    setHeaders: {
      'api_key': environment.apiKey
    }
  });
  
  return next(modifiedRequest);
};

export const addTrackerInterceptor: HttpInterceptorFn = (req, next) => {
  const loginUser = inject(LoginService).loginUser;
  // // Check if the request URL contains any of the ignore requests from environment
  if (req.url.includes('core')) {
    // Clone the request and add the custom header
    const headers: Record<string, string> = {
    //  'tracker': environment.trackerId
    }

    if (loginUser?.email) {
      headers['userId'] = loginUser.email;
    }
    const modifiedRequest = req.clone({
      setHeaders: headers
    });
    return next(modifiedRequest);
  } else {
    return next(req);
  }
  return next(req); // Temporarily disable tracker interceptor
}
